/**
 * Schema of Administrador
 * @author Simpli CLI generator
 */
import {Schema} from 'simpli-web-sdk'
import RenderNumber from '@/components/render/RenderNumber.vue'
import DeliveryUfResponse from '@/model/response/DeliveryUfResponse'

export default (model: DeliveryUfResponse): Schema => ({
  nome: {
    content: model.nome,
  },
  qtdComOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdComOcorrencia,
      },
    },
    textContent: model.qtdComOcorrencia || '0',
  },
  qtdSemOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdSemOcorrencia,
      },
    },
    textContent: model.qtdSemOcorrencia || '0',
  },
  qtdDevolvidas: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdDevolvidas,
      },
    },
    textContent: model.qtdDevolvidas || '0',
  },
  qtdTotal: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdTotal,
      },
    },
    textContent: model.qtdTotal || '0',
  },
})
